// extracted by mini-css-extract-plugin
module.exports = {"lang":"ChangeLang_lang__1auYF","langTitle":"ChangeLang_langTitle__6ND-A","langLtr":"ChangeLang_langLtr__2ypYo"};